import { DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { CoAppActionButton, CoAppCancelTextButton, CoAppCloseIcon, CoAppDialog } from "../../styled/global.styled";

export default function CoAppConfirmationModal(props) {
	const {
		dialogOpen, dialogTitle, dialogMessage,
		confirmClickHandler, cancelClickHandler, actionText
	} = props;
	return (
		<CoAppDialog
			open={dialogOpen}
			onClose={cancelClickHandler}
			slotProps={{
				paper: {
					sx: {
						borderRadius: "8px",
						padding: "8px" 
					}
				}
			}}
		>
			<div>
				<DialogTitle variant="h6">{dialogTitle}</DialogTitle>
				<CoAppCloseIcon onClick={cancelClickHandler} />
			</div>
			<DialogContent>
				<DialogContentText variant="body1" color="textPrimary">{dialogMessage}</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ marginBottom: "15px", marginRight: "12px" }}>
				<CoAppCancelTextButton onClick={cancelClickHandler}>Cancel</CoAppCancelTextButton>
				<CoAppActionButton onClick={confirmClickHandler}>{actionText}</CoAppActionButton>
			</DialogActions>
		</CoAppDialog >
	);
}